import { cn } from "@/lib/utils";
import React from "react";

interface InteractiveHoverButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    firstContent?: string;
    secondaryContent?: string;
}

// Arrow Right Icon component
const ArrowRight = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        className="h-4 w-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
);

export const AnimatedButton = React.forwardRef<
    HTMLButtonElement,
    InteractiveHoverButtonProps
>(({ firstContent, secondaryContent, className, ...props }, ref) => {
    return (
        <button
            ref={ref}
            className={cn(
                "group relative w-auto cursor-pointer overflow-hidden rounded-full bg-gray-200 px-6 py-2 text-center font-semibold text-black dark:text-black",
                className
            )}
            {...props}
        >
            <div className="flex items-center gap-2">
                {/* <div className="indicator h-2 w-2 rounded-full bg-primary-main transition-all duration-300 ease-in-out group-hover:scale-[1.008]" /> */}
                <span className="primary-text inline-block transition-all duration-300 ease-in-out group-hover:translate-x-12 group-hover:opacity-0">
                    {firstContent}
                </span>
            </div>
            <div className="secondary-content absolute top-0 z-10 flex h-full w-full translate-x-12 items-center justify-center gap-2 opacity-0 transition-all duration-300 ease-in-out group-hover:-translate-x-5 group-hover:opacity-100">
                <span>{secondaryContent}</span>
                <ArrowRight />
            </div>
        </button>
    );
});

AnimatedButton.displayName = "InteractiveHoverButton";
